/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDCornerDownRightIcon16Light } from './ArrowDCornerDownRightIcon16Light';
import { ArrowDCornerDownRightIcon16Regular } from './ArrowDCornerDownRightIcon16Regular';
import { ArrowDCornerDownRightIcon16Solid } from './ArrowDCornerDownRightIcon16Solid';
import { ArrowDCornerDownRightIcon20Light } from './ArrowDCornerDownRightIcon20Light';
import { ArrowDCornerDownRightIcon20Regular } from './ArrowDCornerDownRightIcon20Regular';
import { ArrowDCornerDownRightIcon20Solid } from './ArrowDCornerDownRightIcon20Solid';
import { ArrowDCornerDownRightIcon24Regular } from './ArrowDCornerDownRightIcon24Regular';
import { ArrowDCornerDownRightIcon24Solid } from './ArrowDCornerDownRightIcon24Solid';
import { ArrowDCornerDownRightIcon32Regular } from './ArrowDCornerDownRightIcon32Regular';
import { ArrowDCornerDownRightIcon64Regular } from './ArrowDCornerDownRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowDCornerDownRightIcon16Light,
        regular: ArrowDCornerDownRightIcon16Regular,
        solid: ArrowDCornerDownRightIcon16Solid,
    },
    20: {
        light: ArrowDCornerDownRightIcon20Light,
        regular: ArrowDCornerDownRightIcon20Regular,
        solid: ArrowDCornerDownRightIcon20Solid,
    },
    24: {
        regular: ArrowDCornerDownRightIcon24Regular,
        solid: ArrowDCornerDownRightIcon24Solid,
    },
    32: {
        regular: ArrowDCornerDownRightIcon32Regular,
    },
    64: {
        regular: ArrowDCornerDownRightIcon64Regular,
    },
};
export var ArrowDCornerDownRightIcon = forwardRef('ArrowDCornerDownRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
